import History from "./History";
import { ShoppingCartIcon } from "components/Icons";

function Stock(props) {
  return <History {...props} option="current_stock" />;
}

function Sale(props) {
  return <History {...props} option="sale_history" />;
}

function Purchase(props) {
  return <History {...props} option="purchases" />;
}

const getView = () => {
  const DictCtxView = {
    model: "purchase.request",
    table_action: [],
    form_action: [],
    limit: 50,
    pagination: [],
    selectable: "one",
    webfields: {
      "product.name": {
        type: "char",
        readOnly: true,
      },
      party: {
        recName: "name",
        type: "many2one",
        model: "party.party",
        required: true,
        editable: true,
      },
      to_purchase: {
        type: "boolean",
        editable: true,
      },
      "product.code": {
        type: "char",
        readOnly: true,
      },
      "product.description": {
        type: "char",
        readOnly: true,
      },
      "product.rotation": {
        type: "char",
        readOnly: true,
      },
      current_stock: {
        type: "char",
        color: "blue",
        Component: Stock,
        desired_action: "value",
      },
      current_stock_location: {
        type: "numeric",
      },
      sale_history: {
        type: "char",
        color: "blue",
        Component: Sale,
        desired_action: "value",
      },
      quantity: { type: "numeric", editable: true },
      "product.cost_price": {
        type: "numeric",
        // function: getValue,
        readOnly: true,
      },
      purchases: {
        type: "button_custom_modal",
        color: "blue",
        search: false,
        labeled: false,
        icon: <ShoppingCartIcon className="h-5 w-5 fill-white" />,
        readOnly: true,
        Component: Purchase,
      },
    },
    webform: [
      { name: "party" },
      { name: "product" },
      { name: "quantity" },
      { name: "to_purchase" },
      { name: "description" },
    ],
    webtree: [
      { name: "current_stock", width: "5%", widget: "button_custom_modal" },
      { name: "current_stock_location", width: "5%" },
      { name: "sale_history", width: "5%", widget: "button_custom_modal" },
      { name: "quantity", width: "10%", editable: true },
      { name: "to_purchase", width: "5%" },
      { name: "product.code", width: "5%" },
      { name: "product.name", width: "15%" },
      { name: "product.description", width: "5%" },
      { name: "product.cost_price", width: "10%" },
      { name: "purchases", width: "5%", widget: "button_custom_modal" },
      { name: "product.rotation", width: "5%" },
      { name: "party", width: "min-w-[300px]", editable: true },
    ],
  };

  return DictCtxView;
};

export default getView;
